/* 布局 */
//前台
import Layout from "@views/layout";

const sysquestiontypeRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "sysquestiontype/list",
        name: "SYSQUESTIONTYPE",
        meta: {
            title: "题型管理",
        },
        component: () => import("@views/business/sysquestiontype/index.vue"),
    },
        ],
};

export default sysquestiontypeRouter;
